export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MANGA KEITT.b570c396.pdf";